import { useQuery } from 'react-query';

import { publicExportsApi } from 'src/Services/API';
import { PracticalInformationDetailDto } from 'src/Services/API/generated';

const useFetchExportedPracticalInformation = ({
  token,
  practicalInformationId,
}: {
  token: string;
  practicalInformationId: string;
}) => {
  return useQuery({
    queryKey: ['fetch-exported-practical-information', token, practicalInformationId],
    queryFn: async () => {
      return (
        await publicExportsApi.publicExportsControllerFindEntityById(token, practicalInformationId)
      ).data as unknown as PracticalInformationDetailDto;
    },
    staleTime: 5 * 60 * 1000,
    cacheTime: 10 * 60 * 1000,
  });
};

export default useFetchExportedPracticalInformation;
